export const isCmdKey = (e) => {
  return !!e.evt.ctrlKey || !!e.evt.metaKey
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/isCmdKey.js